import React, { useEffect, useState } from 'react';

import BreadcrumbsNav from 'components/BreadcrumbsNav/BreadcrumbsNav';
import Subtitle from 'components/DetailsComponents/Subtitle';
import ConfirmationPopup from 'components/ConfirmationPopup/ConfirmationPopup';

import {
  useMaintenanceRequestActions,
  useMaintenanceRequestSelector
} from 'hooks/MaintenanceRequest';
import { useMobileViewport } from 'hooks/useMobileViewport';
import { useParams } from 'react-router-dom';

import {
  DELETE_MAINTENANCE_REQUEST,
  DELETE_MAINTENANCE_REQUEST_TYPE
} from 'constants/dialogPopupsData';

import Wrapper from './components/Wrapper';
import Header from './components/Header';
import Details from './components/Details';
import Comments from './components/Comments';

export function RequestDetailed() {
  const { id } = useParams();
  const isMobile = useMobileViewport();

  const [modalData, setModalData] = useState({});

  const { getRequestAction, deleteRequestAction, clearStateAction } =
    useMaintenanceRequestActions();
  const { currentRequest } = useMaintenanceRequestSelector();

  useEffect(() => {
    if (id) {
      getRequestAction(id);
    }
  }, []);

  useEffect(() => {
    return () => {
      clearStateAction();
    };
  }, []);

  const handleRemoveRequest = () => {
    setModalData({ ...DELETE_MAINTENANCE_REQUEST, isOpened: true });
  };

  const conditions = {
    breadcrumbs: !isMobile && Boolean(currentRequest?.id),
    comments: Boolean(currentRequest?.comments?.length)
  };

  const closeModal = () => setModalData({});
  const agreeModal = () => {
    if (modalData.type === DELETE_MAINTENANCE_REQUEST_TYPE) {
      deleteRequestAction(id);
    }
  };

  return (
    <Wrapper>
      {conditions.breadcrumbs && (
        <BreadcrumbsNav itemsArray={[{ name: `Request #${currentRequest.id}` }]} />
      )}

      <Header id={id} onRemove={handleRemoveRequest} />

      <Details data={currentRequest} />

      <Subtitle>Comments</Subtitle>

      <Comments data={currentRequest.comments} />

      <ConfirmationPopup data={modalData} onAgree={agreeModal} onDismiss={closeModal} />
    </Wrapper>
  );
}
